import {
  Button,
  Modal,
  Form,
  Input,
  Upload,
  message,
  InputNumber,
  Radio,
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import { MyValidateMessages } from '../../../../utils/validateMessaage'
import { changeBanner, changeGroup, uploadImg } from '../../../../api/api'
import { useEffect } from 'react'
import UploadOnePicture from '../../../../components/upLoadOnePicture/uploadPicture'

export default function EditGroup(props) {
  //表单设置
  const { TextArea } = Input
  const [componentDisabled, setComponentDisabled] = useState(false)
  const onFormLayoutChange = ({ disabled }) => {
    setComponentDisabled(disabled)
  }
  const [form] = Form.useForm()
  const [total, setTotal] = useState(props.total)

  //modal设置
  const [open, setOpen] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [groupImage, setGroupImage] = useState()
  const [codeImage, setCodeImage] = useState()

  //向父组件传递图片网址
  const [url, setUrl] = useState()
  const setImgUrl = (url) => {
    setUrl(url)
    // console.log(url);
  }
  const info = props.groupDetail
  console.log(info)
  const setIsFresh = props.setIsFresh

  useEffect(() => {
    console.log('info', info)
    setUrl(info.image)
    setGroupImage(info.group_image)
    setCodeImage(info.code_image)
  }, [])

  const showModal = () => {
    setOpen(true)
  }
  const handleOk = () => {
    console.log(form.getFieldsValue())
    form.setFieldValue('group_image', groupImage)
    form.setFieldValue('code_image', codeImage)
    form.validateFields().then((res) => {
      const params = Object.assign(res, { id: info.id })
      changeGroup(params).then((res) => {
        console.log(res)
        setOpen(false)
        setIsFresh((pre) => {
          return !pre
        })
        message.success('轮播图修改成功！')
      })
    })
  }
  const handleCancel = () => {
    console.log('Clicked cancel button')
    setOpen(false)
  }

  return (
    <>
      <a onClick={showModal}>编辑</a>
      <Modal
        title="新建/编辑内容"
        okText="确定"
        cancelText="取消"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        destroyOnClose
      >
        <Form
          validateMessages={MyValidateMessages}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          layout="horizontal"
          onValuesChange={onFormLayoutChange}
          disabled={componentDisabled}
          form={form}
          initialValues={info}
        >
          <Form.Item
            label="群聊名称"
            name="name"
            rules={[
              {
                required: true,
                max: 50,
              },
            ]}
          >
            <Input placeholder="上限50字" />
          </Form.Item>

          <Form.Item
            label="状态"
            name="is_visible"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Radio.Group>
              <Radio value={1}>展示</Radio>
              <Radio value={0}>隐藏</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="优先级"
            name="priority"
            rules={[
              {
                type: Number,
                required: true,
                min: 0,
                max: 99,
              },
            ]}
          >
            <InputNumber
              style={{ width: '150px' }}
              placeholder="输入0-99的整数"
            />
          </Form.Item>

          <Form.Item
            label="群聊图片"
            valuePropName="group_image"
            name="group_image"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <UploadOnePicture
              deliverUrl={setGroupImage}
              image={info?.group_image ?? null}
            />
          </Form.Item>

          <Form.Item
            label="群二维码图片"
            valuePropName="code_image"
            name="code_image"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <UploadOnePicture
              deliverUrl={setCodeImage}
              image={info?.code_image ?? null}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
